// @ts-expect-error not migrated yet
import ContentViewContainer from './views/ContentViewContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SettingsContainer() {
  return /*#__PURE__*/_jsx(ContentViewContainer, {});
}